import { z } from 'zod';
import { Channel } from './notification.schema';

export const rateLimitSchema = z.object({
  id: z.string(),
  appId: z.string().nullable().optional(),
  tenantId: z.string().nullable().optional(),
  userId: z.string().nullable().optional(),
  channel: Channel.nullable().optional(),
  softLimit: z.number(),
  hardLimit: z.number(),
  windowSeconds: z.number(),
  action: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  /** `cac` cuando la fila la declara el CaC de la app: se muestra bloqueada. */
  managedBy: z.string().nullable().optional(),
});
export type RateLimit = z.infer<typeof rateLimitSchema>;

export const rateLimitInputSchema = z.object({
  tenantId: z.string().nullable().optional(),
  userId: z.string().nullable().optional(),
  channel: Channel.nullable().optional(),
  softLimit: z.number().int().positive('Soft limit must be positive'),
  hardLimit: z.number().int().positive('Hard limit must be positive'),
  windowSeconds: z.number().int().positive('Window must be positive').optional(),
  action: z.enum(['queue', 'reject']).optional(),
});
export type RateLimitInput = z.infer<typeof rateLimitInputSchema>;
